import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import CarpetUpholstery_Section1 from "./sections/CarpetUpholstery_Section1";

function CarpetUpholsteryCleaning() {
  usePageMeta({
    title: "Carpet & Upholstery Cleaning Ireland | Spechs",
    description:
      "Professional carpet and upholstery cleaning across Ireland. Restore freshness to your fabrics.",
    canonical: "https://www.spechs.ie/cleaning/carpet-upholstery/",
  });
  return (
    <SubPageLayout title="Carpet & Upholstery Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <CarpetUpholstery_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default CarpetUpholsteryCleaning;
